import { render, staticRenderFns } from "./HospitalsModuleComponent.vue?vue&type=template&id=72afba64&scoped=true"
import script from "./HospitalsModuleComponent.vue?vue&type=script&lang=js"
export * from "./HospitalsModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./HospitalsModuleComponent.vue?vue&type=style&index=0&id=72afba64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72afba64",
  null
  
)

export default component.exports